/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-07-03 16:22:11
 * @LastEditors: wl
 * @LastEditTime: 2020-07-03 17:51:51
 */ 
import axios from '../axios'

// 楼栋配置列表
export const handleQuery = (data) => {
    return axios({
        url: '/admin/service/sys_pass_statistics',
        method: 'post',
        data
    })
}

// sys_pass_day_statistics
// 楼栋配置列表
export const handleDay = (data) => {
    return axios({
        url: '/admin/service/sys_pass_day_statistics',
        method: 'post',
        data
    })
}
// 一户一档

export const one_family_one_file = (data) => {
    return axios({
        url: '/admin/service/one_family_one_file',
        method: 'post',
        data
    })
}
// 一户一档获取家庭人员表

export const sys_family_list= (data) => {
    return axios({
        url: '/admin/service/sys_family_list',
        method: 'post',
        data
    })
}
// 一人一档获取家庭人员表

export const person_hasHouse= (data) => {
    return axios({
        url: '/admin/service/person_hasHouse',
        method: 'post',
        data
    })
}
// 一户一档获取车辆信息

export const person_to_car= (data) => {
    return axios({
        url: '/admin/service/person_to_car',
        method: 'post',
        data
    })
}
// 一户一档获取预警信息

export const strategy_log_list= (data) => {
    return axios({
        url: '/admin/service/strategy_log_list',
        method: 'post',
        data
    })
}
// 一户一档获取网格信息

export const ht_grid_info= (data) => {
    return axios({
        url: '/admin/service/ht_grid_info',
        method: 'post',
        data
    })
}

//一户一档业主更新
export const update_owner = (data) => {
    return axios({
        url: '/admin/service/update_owner',
        method: 'post',
        data
    })
}

// sys_person_type
// 人员注册统计
export const person_type = (data) => {
    return axios({
        url: '/admin/service/sys_person_type',
        method: 'post',
        data
    })
}
// sys_person_type
// 一周人员注册统计
export const week_people = (data) => {
    return axios({
        url: '/admin/service/sys_week_people',
        method: 'post',
        data
    })
}
// 昨天sys_yester_rigister
export const yester_rigister = (data) => {
    return axios({
        url: '/admin/service/sys_yester_rigister',
        method: 'post',
        data
    })
}
// 更新一户一档人员关系
export const sys_relation_update = (data) => {
    return axios({
        url: '/admin/service/sys_relation_update',
        method: 'post',
        data
    })
}

// 一天内通行
export const day_hour = (data) => {
    return axios({
        url: '/admin/service/pass_day_hour',
        method: 'post',
        data
    })
}
// 一天内通行
export const day_week = (data) => {
    return axios({
        url: '/admin/service/pass_day_week',
        method: 'post',
        data
    })
}
// 、前七天

export const day_seven = (data) => {
    return axios({
        url: '/admin/service/pass_day_seven',
        method: 'post',
        data
    })
}
// pass_day_type

export const day_type = (data) => {
    return axios({
        url: '/admin/service/pass_day_type',
        method: 'post',
        data
    })
}

//人员类型每小时通行趋势
export const pass_type_day_cid = (data) => {
    return axios({
        url: '/admin/service/pass_type_day_cid',
        method: 'post',
        data
    })
}
//人员类型上周每天通行趋势
export const pass_type_week_cid = (data) => {
    return axios({
        url: '/admin/service/pass_type_week_cid',
        method: 'post',
        data
    })
}
//视频列表
export const video_list = (data) => {
    return axios({
        url: '/admin/service/video_list',
        method: 'post',
        data
    })
}

//视频添加
export const video_add = (data) => {
    return axios({
        url: '/admin/service/video_add',
        method: 'post',
        data
    })
}
//人员查询车辆信息

export const car_getlist = (data) => {
    return axios({
        url: '/admin/service/sys_car_getList',
        method: 'post',
        data
    })
}
//人员查询车辆通行记录
export const sys_carPass_list = (data) => {
    return axios({
        url: '/admin/service/sys_carPass_list',
        method: 'post',
        data
    })
}
//人员查询通行记录

export const sys_pass_list = (data) => {
    return axios({
        url: '/admin/service/sys_pass_list',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/home.js